module.exports = __webpack_public_path__ + "media/images/update_placeholder-437e6c7b5077798b82182de6ac18b207.jpg";